import { Component, OnInit } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { TableComponent } from 'src/app/models/components/objectComponents/TableComponent';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { RackComponent } from 'src/app/models/components/objectComponents/RackComponent';
import { PodestComponent } from 'src/app/models/components/commonComponents/PodestComponent';
import { Shelf } from 'src/app/models/other/shelf.model';
import { Box } from 'src/app/models/other/box.model';
import { MatDialogRef } from '@angular/material/dialog';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-tablewithstorage',
  templateUrl: './tablewithstorage.component.html',
  styleUrls: ['./tablewithstorage.component.scss']
})
export class TablewithstorageViewComponent extends BaseAdvancedPropertyViewComponent {
  table: TableComponent;
  rack: RackComponent = new RackComponent();
  podest: PodestComponent = new PodestComponent();
  shelfArrLeft: Array<Shelf> = new Array<Shelf>();
  shelf:Shelf;
  integerOnly = InputHelper.integerOnly;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.table = getComponentFromSource(ComponentNames.tableComponent, this.items);
    this.rack = getComponentFromSource(ComponentNames.rackComponent, this.items);
    this.podest = getComponentFromSource(ComponentNames.podestComponent, this.items);
    this.shelfArrLeft = this.rack.shelves[0];
    if(this.shelfArrLeft.length === 0){
      let shelf: Shelf = new Shelf();
      shelf.box = new Box();
      shelf.shelfStart = 0;
      this.shelfArrLeft.push(shelf);
    }
    this.shelf = this.shelfArrLeft[0];
  }

  saveButtonDisabledState(): boolean {
    return false;
  }
}
